/**
 * Created by mac on 7/24/17.
 */

const RewardGoldView = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.createBackground();
        this.icon = this.createIcon();
        this.text = this.createText();

        this.onResize();

        Game.currentGame.on("rewardHard", this.createListener(this.runCollectAnimation.bind(this)));

        cleverapps.tooltipManager.create(this, {
            text: Messages.get("RewardGoldTooltip"),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW
        });

        cleverapps.aims.registerTarget("rewardHard", this, {
            controls: "rewardElementGold",
            toggle: this.createListener((visible, silent) => {
                this.aimVisible = visible;
                this.toggle(this.controlsVisible, silent);
            }),
            flyingUnderShadow: true
        });
    },

    toggle: function (visible, silent) {
        this.controlsVisible = visible;

        if (!this.aimVisible && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            visible = false;
        }

        if (visible) {
            this.show && this.show(silent);
        } else {
            this.hide && this.hide(silent);
        }
    },

    onResize: function () {
        this.setContentSize2(cleverapps.styles.RewardGoldView);
        this.setAlignment(cleverapps.styles.RewardGoldView.position);

        this.background.setContentSize2(cleverapps.styles.RewardGoldView);
        this.toggle(this.controlsVisible, true);

        this.icon.setAlignment(cleverapps.styles.RewardGoldView.icon);
        this.background.setAlignment(this.width / 2, this.height / 2);
        this.text.setAlignment(cleverapps.styles.RewardGoldView.text);
    },

    createBackground: function () {
        const background = this.background = cleverapps.UI.createScale9Sprite(bundles.reward_element.frames.reward_element_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        this.addChild(background);
        return background;
    },

    createIcon: function () {
        const icon = new cleverapps.Spine(bundles.card.jsons.marks_json);
        icon.setAnimation(0, "coin_idle_counter", true);
        this.addChild(icon);
        return icon;
    },

    createText: function () {
        const text = cleverapps.UI.generateImageText(
            Game.currentGame.rewards[GameBase.REWARD_HARD],
            cleverapps.styles.FONTS.HARD_REWARD_TEXT
        );
        text.fitTo(cleverapps.styles.RewardGoldView.text.width);
        this.addChild(text);
        return text;
    },

    runCollectAnimation: function () {
        this.stopAllActions();
        this.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("ui.reward.gold"),
            new cc.ScaleTo(0.15, 1.1),
            new cc.CallFunc(() => {
                this.text.setString(Game.currentGame.rewards[GameBase.REWARD_HARD]);
                this.text.fitTo(cleverapps.styles.RewardGoldView.text.width);
            }),
            new cc.ScaleTo(0.15, 1)
        ));
    }

});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    HARD_REWARD_TEXT: {
        name: "default",
        size: 40
    }
});

cleverapps.styles.RewardGoldView = {
    width: 150,
    height: 61,

    position: [
        {
            x: { align: "left", dx: 60 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 60 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 60 },
            y: { align: "top", dy: -150 }
        }
    ],

    icon: {
        x: 20,
        y: 40
    },

    text: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: 2 },
        width: 70
    }
};
